/* tslint:disable */
/* eslint-disable */
export enum LevelType {
    L0Underground = 'L0_UNDERGROUND',
    L1Ground = 'L1_GROUND',
    L2Floor = 'L2_FLOOR',
    L3Roof = 'L3_ROOF',
    L4Unidentified = 'L4_UNIDENTIFIED'
}
